import Contact from './contact';
import Customer from './customer';
import Package from './package';
import Vehicle from './vehicle';
import Shipping from './shipping';
import Installer from './installer';
import Payment from './payment';

class Contract {
    public contact: Contact;
    public customer: Customer;
    public package: Package;
    public vehicle: Vehicle;
    public shipping: Shipping;
    public installer: Installer;
    public payment: Payment;

    constructor() {
        this.contact = new Contact();
        this.customer = new Customer();
        this.package = new Package();
        this.vehicle = new Vehicle();
        this.shipping = new Shipping();
        this.installer = new Installer();
        this.payment = new Payment();
    }

    static from(json: any) {
        return Object.assign(new Contract(), json);
    }
}

export default Contract;
